import {LanguageModel} from "./language.model";

export class EuModel {

  constructor(){}

  public descriptionKey: string;
  public defaultLanguage: string;
  public visible: boolean;
  public omnisLogo: string;
  public omnisLogoWcag: string;
  public languages: LanguageModel[];

}
